<template>
  <div class="dashboard">
    <h1>市场监控</h1>
    <div class="section-header">
      <h2>自动刷新设置</h2>
      <div>
        <label>
          <input type="checkbox" v-model="isAutoRefreshEnabled" @change="toggleAutoRefresh">
          启用自动刷新
        </label>
        <label>
          刷新间隔（秒）:
          <input type="number" v-model.number="refreshInterval" min="1" @change="updateRefreshInterval">
        </label>
      </div>
    </div>
    <div class="section" v-if="showJJXT">
      <h2>竞价系统</h2>
      <table>
        <thead>
          <tr>
            <th>代码</th>
            <th>名称</th>
            <th>涨幅</th>
            <th>名称</th>
            <th>概念</th>
            <th>名称</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in JJXTList" :key="index">
            <td><a :href="`/stock-detail?stock_code=${item[0]}`" target="_blank">{{ item[0] }}</a></td>
            <td><a :href="`https://www.iwencai.com/unifiedwap/result?querytype=stock&w=${item[1]}`" target="_blank">{{ item[1] }}</a></td>
            <td :class="{'negative': item[2] > 0, 'positive': item[2] < 0}">{{ item[2] }}%</td>
            <td>{{ item[3] }}</td>
            <td>{{ item[4] }}</td>
            <td>{{ item[5] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
      <div class="section">
      <h2>最强风口</h2>
      <table>
        <thead>
          <tr>
            <th>代码</th>
            <th>名称</th>
            <th>强度</th>
            <th>涨跌幅</th>
            <th>所属概念</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in ZQFKList" :key="index">
            <td><a :href="`/stock-detail?stock_code=${item[0]}`" target="_blank">{{ item[0] }}</a></td>
            <td><a :href="`https://www.iwencai.com/unifiedwap/result?querytype=stock&w=${item[1]}所属概念`" target="_blank">{{ item[1] }}</a></td>
            <td>{{ item[2] }}</td>
            <td :class="{'negative': item[3] > 0, 'positive': item[3] < 0}">{{ item[3] }}%</td>
            <td>
                 <!-- 将 item[4] 按顿号分割并生成链接 -->
                  <span v-for="(concept, index) in item[4].split('、')" :key="index">
                    <a
                      :href="`https://www.iwencai.com/unifiedwap/result?querytype=stock&w=${concept}概念中股性最好的股票`"
                      target="_blank"
                    >
                      {{ concept }}
                    </a>
                    <!-- 如果不是最后一个元素，添加顿号分隔 -->
                    <span v-if="index < item[4].split('、').length - 1">、</span>
                  </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="section">
      <h2>最近活跃</h2>
      <table>
        <thead>
          <tr>
            <th>代码</th>
            <th>名称</th>
            <th>涨跌幅</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in BaceFaceList" :key="index">
            <td><a :href="`/stock-detail?stock_code=${item[2]}`" target="_blank">{{ item[2] }}</a></td>
            <td><a :href="`https://www.iwencai.com/unifiedwap/result?querytype=stock&w=${item[0]}`" target="_blank">{{ item[0] }}</a></td>
            <td :class="{'negative': item[1] > 0, 'positive': item[1] < 0}">{{ item[1] }}%</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="section">
      <h2>人气排行榜</h2>
      <table>
        <thead>
          <tr>
            <th>代码</th>
            <th>名称</th>
            <th>涨幅</th>
            <th>排名</th>
            <th>连扳数</th>
            <th>概念</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in PHBList" :key="index">
            <td>{{ item[0] }}</td>
            <td><a :href="`https://www.iwencai.com/unifiedwap/result?querytype=stock&w=${item[1]}`" target="_blank">{{ item[1] }}</a></td>
            <td :class="{'negative': item[2] > 0, 'positive': item[2] < 0}">{{ item[2] }}%</td>
            <td>{{ item[3] }}</td>
            <td>{{ item[4] }}</td>
            <td>{{ item[5] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="section">
      <h2>严重异动提醒</h2>
      <table>
        <thead>
          <tr>
            <th>代码</th>
            <th>名称</th>
            <th>涨跌幅</th>
            <th>触发条件</th>
            <th>当前涨幅</th>
            <th>累计涨幅</th>
            <th>触发严重异动条件</th>
            <th>收盘涨幅</th>
            <th>累计涨幅（收盘）</th>
            <th>备注</th>
            <th>波动率</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in PLZList" :key="index">
            <td><a :href="`/stock-detail?stock_code=${item[0]}`" target="_blank">{{ item[0] }}</a></td>
            <td><a :href="`https://www.iwencai.com/unifiedwap/result?querytype=stock&w=${item[1]}`" target="_blank">{{ item[1] }}</a></td>
            <td :class="{'negative': item[4] > 0, 'positive': item[4] < 0}">{{ item[4] }}%</td>
            <td>{{ item[3] }}</td>
            <td :class="{'negative': item[7] > 0, 'positive': item[7] < 0}">{{ item[7] }}%</td>
            <td>{{ item[6] }}%</td>
            <td>{{ item[5] }}</td>
            <td :class="{'negative': item[8] > 0, 'positive': item[8] < 0}">{{ item[8] }}%</td>
            <td>{{ item[9] }}%</td>
            <td>{{ item[10] }}</td>
            <td>{{ item[11] }}%</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      BaceFaceList: [],
      PHBList: [],
      JJXTList: [],
      PLZList: [],
      ZQFKList: [],
      refreshInterval: 60, // 默认刷新间隔为30秒
      timer: null, // 用于存储定时器
      isAutoRefreshEnabled: true, // 默认启用自动刷新
      showJJXT: true // 控制竞价系统显示状态
    };
  },
  created() {
    this.fetchStockIndex();
    this.updateJJXTVisibility(); // 初始化竞价系统的显示状态
    if (this.isAutoRefreshEnabled) {
      this.startAutoRefresh(); // 启动自动刷新
    }
  },
  beforeUnmount() {
    this.stopAutoRefresh(); // 组件销毁前清除定时器
  },
  methods: {
    async fetchStockIndex() {
      try {
        const response = await axios.get('/api/stock_index');
        const data = response.data;

        // 处理数据

        this.BaceFaceList = data.BaceFaceList || [];
        this.PHBList = data.PHBList || [];
        this.JJXTList = data.JJXTList || [];
        this.PLZList = data.PLZList || [];
        this.ZQFKList = data.ZQFKList || [];
        console.log('got data:', this.PHBList);
      } catch (error) {
        console.error('Error fetching stock index:', error);
      }
    },
    startAutoRefresh() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        this.fetchStockIndex();
        this.updateJJXTVisibility(); // 每次刷新时更新竞价系统的显示状态
      }, this.refreshInterval * 1000); // 将秒转换为毫秒
    },
    stopAutoRefresh() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    toggleAutoRefresh() {
      if (this.isAutoRefreshEnabled) {
        this.startAutoRefresh();
      } else {
        this.stopAutoRefresh();
      }
    },
    updateRefreshInterval() {
      if (this.isAutoRefreshEnabled) {
        this.startAutoRefresh(); // 重新启动定时器以应用新的刷新间隔
      }
    },
    updateJJXTVisibility() {
      const now = new Date();
      const cutoffTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 9, 30, 0); // 早上9:30
      this.showJJXT = now < cutoffTime;
    }
  }
};
</script>

<style scoped>
.dashboard {
  padding: 20px;
  font-family: Arial, sans-serif;
  background-color: #f9f9f9;
  color: #333;
}

h1 {
  color: #333;
  text-align: center;
  margin-bottom: 20px;
  font-size: 24px;
}

.section {
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

h2 {
  color: #333;
  margin-bottom: 10px;
  font-size: 20px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 14px;
}

th {
  background-color: #007bff;
  color: #fff;
  padding: 12px;
  text-align: left;
  border-bottom: 2px solid #ddd;
}

td {
  padding: 12px;
  border-bottom: 1px solid #ddd;
}

tr:hover {
  background-color: #f1f1f1;
  cursor: pointer;
}

.positive {
  color: #28a745; /* Green */
}

.negative {
  color: #dc3545; /* Red */
}

a {
  color: #007bff;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

p {
  color: #666;
  text-align: center;
  margin: 10px 0;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.section-header h2 {
  margin: 0;
}

.section-header .filter {
  font-size: 14px;
  color: #007bff;
  cursor: pointer;
}

.section-header .filter:hover {
  text-decoration: underline;
}

.section-header label {
  margin-right: 10px;
}
</style>
